import React from "react"
import {List} from "./component"

type StandardListProps = {
    isDirectLink: boolean
    children: React.ReactNode
}

export const StandardList = ({isDirectLink, children}: StandardListProps) => {
    return (
        <List data-testid="catalogue-items" isDirectLink={isDirectLink}>
            {children}
        </List>
    )
}

export default StandardList
